import React, { useState } from "react";
import axios from "axios";
import {
  Container,
  TextField,
  Button,
  Typography,
  CardContent,
  Card,
} from "@mui/material";
import API_URL from "../../config";
import API_BASE_URL from "../../utils/api";

const ResendVerification = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleResend = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        `${API_BASE_URL}/auth/resend-verification-email`,
        {
          email,
        }
      );
      setMessage(res.data.message);
    } catch (err) {
      setMessage(
        err.response?.data?.error || "Failed to resend verification email."
      );
    }
  };

  return (
    <Container maxWidth="xs" style={{ marginTop: "80px" }}>
      <Card elevation={4}>
        <CardContent>
          <Typography variant="h5" align="center" gutterBottom>
            Resend Verification Email
          </Typography>
          <form
            onSubmit={handleResend}
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 20,
              marginTop: 20,
            }}
          >
            <TextField
              label="Email Address"
              type="email"
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              fullWidth
            />
            <Button variant="contained" color="primary" type="submit" fullWidth>
              Resend Email
            </Button>
            {message && (
              <Typography
                style={{ marginTop: 10 }}
                color={message.includes("successfully") ? "green" : "error"}
              >
                {message}
              </Typography>
            )}
          </form>
        </CardContent>
      </Card>
    </Container>
  );
};

export default ResendVerification;
